var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LinkTemplate',{attrs:{"loading":_vm.isLoading,"fazenda":_vm.fazenda},on:{"bundle-kmz":_vm.downloadBundleKmz}})
}
var staticRenderFns = []

export { render, staticRenderFns }